import { takeLatest, select, call, put, all } from 'redux-saga/effects';
import * as cnt from './constants';
import { apiSaga } from '../../../sagas';
import { callApi, contracting as contractingApis } from '../../../api';
import { delay } from "redux-saga";
import R from 'ramda';
import querystring from "query-string";
import docCookies from '../../../utils/docCookie';

function* loadWidgetData(widgetState) {
  const globalFiltersState = yield select(state => state.contractingDashboard.globalFilters);
  const currentYear = yield select(state => state.contracting.currentYear);
  const startInCookie = docCookies.getItem('contractYearStartDate');
  const endInCookie = docCookies.getItem('contractYearEndDate');
  const globalFilters = Object.entries(globalFiltersState)
  .map(([key, value]) => {
    if (value.key === 'locations') {
      return ({ locations: value.list.filter(obj => obj.checked).map(R.prop('locId')) });
    }
    if (value.key === 'folder') {
      return ({ folder: value.list.filter(obj => obj.checked).map(R.prop('value')) });
    }
    return ({ [key]: value.selectedValue });
  })
  .reduce((obj, item) => Object.assign({
    contractingPeriod: `${currentYear.startDate || startInCookie}|${currentYear.endDate || endInCookie}`,
  }, { ...item }, obj));

  const { id, url, filters } = widgetState;
  const filterObj = {};
  Object.values(filters || {}).forEach(({ filterValue, filterBy }) => {
    if (filterValue) {
      filterObj[filterBy] = filterValue;
    }
  });
  const query = querystring.stringify({ ...globalFilters, ...filterObj });
  yield* apiSaga(cnt.UPDATE_WIDGET_DATA, () => callApi(`/proxy${url}?${query}`), [{ widgetId: id }]);
}

function* loadDashboard() {
  const items = yield select(state => state.contractingDashboard.items);
  yield all(items.map(loadWidgetData))
}

function* handleYearChange() {
  if (window.location.pathname.indexOf('dashboard') > -1) {
    yield* loadDashboard();
  }
}

function* handleInit() {
  const currentYear = yield select(state => state.contracting.currentYear);
  const startInCookie = docCookies.getItem('contractYearStartDate');
  if (currentYear.startDate || startInCookie) {
    yield* loadDashboard();
  }
}

function* loadFolders({ type }) {
  yield* apiSaga(type, contractingApis.getFolders, []);
}

function* handleWidgetFilterUpdate({ payload }) {
  const widgetState = yield select(state => state.contractingDashboard.items.find(item => item.id === payload.id));
  yield* loadWidgetData(widgetState);
}

export default [
  takeLatest('[contracting]SELECTED_YEAR_FOR_CONTRACTING', handleYearChange),
  takeLatest(cnt.INIT_DASHBOARD, handleInit),
  takeLatest(cnt.LOAD_DASHBOARD, loadDashboard),
  takeLatest(cnt.RESET_GLOBAL_DASHBOARD_FILTER, loadDashboard),
  takeLatest(cnt.LOAD_FOLDERS, loadFolders),
  takeLatest(cnt.UPDATE_WIDGET_FILTER, handleWidgetFilterUpdate)
];



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/__storeFiles__/sagas.js